import { useMemo } from 'react'

import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { map } from 'lodash'
import { brReportToReportMapper } from 'pages/your-personal-data/components/reports-history/utils/mappers'

import { useQuery } from '@tanstack/react-query'

import { getReportsUnderAnalysisQueryOptions } from './queries/getReportsUnderAnalysisQueryOptions'

export const useGetReportsUnderAnalysis = () => {
  const { userCountry, privacyCenterContent, isUSBranch, userSelectedEntity } = useAppContext()

  const endpoint = privacyCenterContent?.endpoints?.reports?.getReportsInAnalysis

  const {
    data,
    isLoading: isReportsUnderAnalysisLoading,
    isError: isReportsUnderAnalysisError,
  } = useQuery(
    getReportsUnderAnalysisQueryOptions({
      endpoint,
      userCountry,
      userSelectedEntity,
      isUSBranch,
    }),
  )

  const reportsUnderAnalysis = useMemo(() => {
    if (!data) return undefined

    if (userCountry === 'BR' && 'historicoRelatorioSolicitacoes' in data) {
      return map(data.historicoRelatorioSolicitacoes, (report) => brReportToReportMapper(report))
    }

    if ('dataRequestsAnalysis' in data) {
      return data.dataRequestsAnalysis
    }

    return undefined
  }, [data, userCountry])

  return {
    reportsUnderAnalysis,
    isReportsUnderAnalysisLoading,
    isReportsUnderAnalysisError,
  }
}
